import React from 'react';
import { PageWrapper, ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { Skeleton, SkeletonCircle, Flex } from '@chakra-ui/react';

export const SongLoader = () => (
  <PageWrapper py={4} px={0} w="full">
    <ContentContainer type={ContentContainerType.LIST}>
      <Flex>
        <SkeletonCircle
          height={128}
          minWidth={128}
          borderBottomLeftRadius="10%"
          borderTopLeftRadius="10%"
          borderRadius="50%"
        />
        <Flex
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
          ml={4}
          w="full"
        >
          <Skeleton
            height="42px"
            width="100%"
            maxWidth="500px"
            margin="6px 0px 7px"
          />
          <Skeleton height="28px" width="96px" />
        </Flex>
      </Flex>
    </ContentContainer>
  </PageWrapper>
);
